export default __webpack_public_path__ + "static/media/Comp 2_00042.cd986674.png";